export default [
  {
    path: '/admin/trader/strategy-doctor',
    name: 'StrategyDoctor',
    component: () => import('@/views/Admin/Trader/StrategyDoctor/Index.vue'),
    meta: {
      pageTitle: 'Strategy Doctor',
      breadcrumb: [
        { text: 'Trader', active: false },
        { text: 'Strategy Doctor', active: true },
      ],
      resource: 'targets.list',
      action: 'read',
    },
  },
]
